
<script lang="ts" setup>
// ---------------------------------------
// Hooks
// ---------------------------------------
const route = useRoute();

const { data, error } = await useAsyncData(
  `blog_post_${route.params.slug}`, 
  () => $fetch(`/api/blog/post/${route.params.slug}`),  
);

// ---------------------------------------
// Meta
// ---------------------------------------

useHead(() => ({
  title: data.value?.title,
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: data.value?.excerpt,
    },
    {
      hid: 'keywords',
      name: 'keywords',
      content: data.value?.seo.keywords
    }
  ],
}));
</script>

<template>
  <main class="block py-40 px-4 md:px-10">
    <div class="max-w-7xl mx-auto">
      <header class="block mb-16">
        <!-- Category -->
        <span class="block my-2">
          {{ data?.categories[0]?.name }}
        </span>
        <h1 class="text-3xl md:text-7xl">
          {{ data?.title }}
        </h1>
        <div class="my-4 flex flex-col md:flex-row gap-2 md:items-center">
          <div>
            <span class="inline-flex items-center justify-center avatar rounded-full bg-gray-100 border-2 border-gray-200 dark:bg-neutral-600 dark:border-neutral-700">
              <span class="font-medium text-gray-500 leading-none dark:text-neutral-400">
                {{ data?.author?.firstName[0] }}
              </span>
            </span>
            <span class="mx-2">
              {{ data?.author?.firstName }} {{ data?.author?.lastName }}
            </span>
          </div>

          <span class="hidden md:block">
            |
          </span>

          <span>
            {{ $dayjs(data?.createdAt).format('LL') }}
          </span>

        </div>
      </header>

      <article>
        <!-- Hero image -->
        <figure
          v-if="data?.featuredImage"
          class="hero-img-header object-fill w-full overflow-hidden mb-7 lg:mb-28"
        >
          <img :src="data.featuredImage.url">
        </figure>
        <section>
          <Markdown :content="data?.markdown || ''"/>
        </section>
      </article>
    </div>
  </main>
</template>
<style lang="scss" scoped>
main {
  background-color: #fff;

  ul {
    li:not(:last-child) {
      margin-bottom: 32px;
    }
  }

  article {
    p {
      margin-bottom: 1.57em;
      @apply text-lg;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-bottom: 0.56em;
    }
  }
}

.avatar {
  width: 30px;
  height: 30px;
}

.hero-img-header {
  height: 280px;

  img {
    width: 100%;
    object-fit: cover;
  }
}

@media (screen(lg)) {
  .hero-img-header {
    height: calc(100vh / 1.8);
    min-height: 320px;
  }
}
</style>